import React from "react";
import LuvitComponent from "LuvitComponent";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { generateRandomKeyIdString } from "lib/utils";
import { autobind } from "lib/decorators";

let State = new (class DropdownState {
  @observable activeDropdown = null;
})();

@observer
@autobind
export default class CategoryDropdown extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
  }

  componentWillMount() {
    this.dropdownId = generateRandomKeyIdString();
  }

  componentDidMount() {
    let category = luvit.GetQueryString("category");
    let categoryID = luvit.GetQueryString("categoryID");

    if (category) {
      const categoryID = this.getCategoryIDByTitle(category);
      if (categoryID) {
        this.props.onChange(categoryID);
      }
    }
    if (categoryID) {
      this.props.onChange(categoryID);
    }
  }

  toggleExpanded() {
    State.activeDropdown =
      State.activeDropdown === this.dropdownId ? undefined : this.dropdownId;
  }

  setSelected(choice) {
    let selectedId = choice ? choice.trainingCategoryId : this.props.parentId;
    State.activeDropdown = null;
    this.props.onChange(selectedId);
  }

  getCategoryIDByTitle(category) {
    let option = this.props.options.filter(
      (option) => option.categoryTitle.toLocaleLowerCase() == category,
    );
    return option[0] ? option[0].trainingCategoryId : null;
  }

  render() {
    let isActive = State.activeDropdown === this.dropdownId;
    let selected =
      this.props.selected !== undefined
        ? this.props.options.find(
            (o) => o.trainingCategoryId === this.props.selected,
          )
        : null;

    return (
      <div className="cardview-category">
        <button
          className="cardview-category-box flex flex-space-b align-c"
          onClick={this.toggleExpanded}
        >
          <span className="flex flex-space-b align-c">
            <div className="cardview-category-box-title">
              {selected ? selected.categoryTitleTranslated : this.l("all")}
            </div>
            <span className="icon-bars" aria-hidden="true" />
          </span>
        </button>
        <div
          className={
            isActive ? "cardview-category-list animated fadeInDown" : "hidden"
          }
        >
          <button onClick={() => this.setSelected(null)}>
            {this.l("all")}
          </button>
          {this.props.options.map((c) => (
            <button
              key={c.trainingCategoryId}
              onClick={() => this.setSelected(c)}
            >
              <div className="flex">
                <span
                  className={
                    selected && selected === c
                      ? "icon-check"
                      : "cardview-category-space"
                  }
                  aria-hidden="true"
                />
                &nbsp;<span>{c.categoryTitleTranslated}</span>
              </div>
              <span>&nbsp;&nbsp;{c.noOfCourses}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }
}
